import { ReactComponent as SupportIconSVG } from '@/assets/icons/SupportIcon.svg';
import { SVGProps } from 'react';

const SupportIcon = (props: SVGProps<SVGSVGElement>) => <SupportIconSVG {...props} />;

export default SupportIcon;
